'use es6';
/**
 * Fork of UIComponents/nav/UINavList
 * https://git.hubteam.com/HubSpot/UIComponents/blob/e8c8ab2/UIComponents/static-3.800/js/nav/UINavList.js
 */

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isValidElement, cloneElement, Children, Component } from 'react';
import classNames from 'classnames';
import { isChildActive, containsActiveChild } from './utils/navUtils';
import { MICROCOPY_SIZE } from 'HubStyleTokens/sizes';
import HR from 'UIComponents/elements/HR';
import H7 from 'UIComponents/elements/headings/H7';
const Ul = styled.ul.withConfig({
  displayName: "NavList__Ul",
  componentId: "sc-1iwii81-0"
})(["list-style:none;padding-left:0;margin-bottom:4px;& .nav__wrapper{.nav-item{font-size:", ";padding-bottom:8px;padding-top:8px;padding-left:24px;}}", ""], MICROCOPY_SIZE, ({
  depth
}) => depth === 0 ? `margin-bottom: 0;` : ``);
const Nav = styled.nav.withConfig({
  displayName: "NavList__Nav",
  componentId: "sc-1iwii81-1"
})(["margin-bottom:20px;.nav__wrapper{margin-bottom:0;}"]);

class NavList extends Component {
  constructor(...args) {
    super(...args);

    this.rerenderFromRoot = children => {
      if (children == null) return null;
      const {
        depth,
        value,
        _rootComponent,
        _transformChildProps
      } = this.props;
      const Root = _rootComponent || NavList;
      const props = {
        depth: depth + 1,
        value,
        _rootComponent,
        _transformChildProps
      };
      return /*#__PURE__*/_jsx(Root, Object.assign({}, props, {
        children: children
      }));
    };
  }

  render() {
    const _this$props = this.props,
          {
      children,
      className,
      depth,
      _transformChildProps,
      value
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "depth", "_rootComponent", "_transformChildProps", "value"]);

    const classes = classNames(className, 'nav__wrapper');
    return /*#__PURE__*/_jsx(Nav, Object.assign({}, rest, {
      className: classes,
      children: /*#__PURE__*/_jsx(Ul, {
        depth: depth,
        children: Children.map(children, child => {
          if (! /*#__PURE__*/isValidElement(child)) {
            return child;
          }

          const defaultOpen = child && child.props && child.props.defaultOpen;

          if (child.type === HR || child.type === H7) {
            return child; // to prevent a console warning as a result of UINestedNav having H7 or HR as children
          }

          return /*#__PURE__*/cloneElement(child, Object.assign({
            active: isChildActive(child, value),
            defaultOpen: defaultOpen || containsActiveChild(child, value),
            value: undefined,
            _rootRenderer: this.rerenderFromRoot
          }, _transformChildProps(child.props)));
        })
      })
    }));
  }

}

NavList.displayName = 'NavList';
NavList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number,
  value: PropTypes.node,
  _rootComponent: PropTypes.func,
  _transformChildProps: PropTypes.func
};
NavList.defaultProps = {
  depth: 0,
  value: null,
  _transformChildProps: () => ({})
};
export default NavList;